const NavCenterText = () => {
  return <span className='display-6'>Izz Hafeez</span>;
};

export default NavCenterText;